import logo from '../../assets/logo.png';
import { contactLinks } from '../../data/contactLinks';

const links = [
  { id: 'home', label: 'Home' },
  { id: 'services', label: 'Services' },
  { id: 'success-stories', label: 'Success Stories' },
  { id: 'about', label: 'About Us' },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={logo} alt="Wedding Tech logo" className="footer-logo" />
            <p className="footer-tagline">
              Everything you need for your big day — from bespoke websites to RSVP tracking and AI-powered guest care.
            </p>
          </div>
          <div className="footer-links">
            <p className="footer-heading">Explore</p>
            <nav aria-label="Footer navigation">
              {links.map((link) => (
                <a key={link.id} href={`#${link.id}`} className="footer-link">
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
          <div className="footer-connect">
            <p className="footer-heading">Connect</p>
            <ul className="footer-contact-list">
              {contactLinks.map((contact) => (
                <li key={contact.id}>
                  <a
                    className="footer-contact-link contact-link"
                    href={contact.href}
                    target={contact.external ? '_blank' : undefined}
                    rel={contact.external ? 'noopener noreferrer' : undefined}
                    aria-label={`${contact.label}: ${contact.display}`}
                  >
                    <span className="contact-link__icon" aria-hidden="true">
                      <i className={contact.iconClass} />
                    </span>
                    <span className="contact-link__label">{contact.display}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-note">
        <div className="container">
          <small>© {year} WeddingTech. All rights reserved.</small>
        </div>
      </div>
    </footer>
  );
};
